import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import IDemoConfig from '../../types/IDemoConfig';

interface IGetDemoConfig {
  demoConfig: IDemoConfig;
}

export const GET_DEMO_CONFIG = gql`
  query demoConfig {
    demoConfig {
      enabled
      uploadAllowed
      dropboxAllowed
      analysisAllowed
      analysisNextAttemptAt
      reportAllowed
      reportNextAttemptAt
    }
  }
`;

export default (options?: QueryHookOptions) => {
  return useQuery<IGetDemoConfig>(GET_DEMO_CONFIG, options);
};
